module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.is_auth === true) ? _c('div', [_c('nav', {
    staticClass: "navbar navbar-default navbar-fixed-top",
    staticStyle: {
      "right": "-15px"
    }
  }, [_c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "padding-right": "30px"
    }
  }, [_c('div', {
    staticClass: "navbar-header pull-left"
  }, [_c('button', {
    staticClass: "navbar-toggle collapsed",
    class: {
      'taped': _vm.sideMenuVisible
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleSideMenu($event)
      }
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-brand w5-navbar-logo-link hidden-xs",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "w5-navbar-logo-img visible-xs",
    attrs: {
      "src": _vm.stylePathToLogo || '/static/img/logo/logo.png'
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "w5-navbar-logo-img hidden-xs",
    attrs: {
      "src": _vm.stylePathToLogoText || '/static/img/logo/logo-text.png'
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-header pull-right"
  }, [_c('Lang'), _vm._v(" "), (_vm.$store.state.user_account) ? _c('router-link', {
    staticClass: "navbar-brand w5-navbar-link linkified",
    attrs: {
      "to": "/dashboard/info"
    }
  }, [_c('span', {
    staticClass: "w5-account-info"
  }, [_vm._v(_vm._s(this.$store.state.user_account) + " ")])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-brand w5-navbar-link linkified",
    attrs: {
      "to": "/options"
    }
  }, [_c('img', {
    staticClass: "user-mini-avatar",
    attrs: {
      "src": _vm.APIServerUrl + this.$store.state.user_avatar
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(" " + _vm._s(this.$store.state.user_login))])]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-brand w5-navbar-link last-right",
    attrs: {
      "to": "/logout"
    }
  }, [_c('font-awesome-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.form_Loading),
      expression: "!form_Loading"
    }],
    attrs: {
      "icon": "lock"
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form_Loading),
      expression: "form_Loading"
    }],
    staticClass: "pull-left",
    attrs: {
      "src": "/static/img/loading16.gif"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(" " + _vm._s(_vm.localeFtc('main/logout')))])], 1)], 1)])]), _vm._v(" "), (this.$store.state.user_type === 'client') ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBalanceData),
      expression: "showBalanceData"
    }],
    staticClass: "mobile-client-balance",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showBalanceData = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("ftc")('operation/real_balance_short')) + ":")]), _vm._v(" "), (_vm.$store.state.user_balance.real !== '') ? _c('span', {
    staticClass: "font-weight-500"
  }, [_c('a', {
    class: {
      'color-red': this.$store.state.user_balance.real < 0
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.GoToOperation('real')
      }
    }
  }, [_c('Money', {
    attrs: {
      "value": _vm._f("money2")(this.$store.state.user_balance.real)
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "font-weight-500",
    domProps: {
      "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
    }
  })]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("ftc")('operation/purse_bonus')) + ":")]), _vm._v(" "), (_vm.$store.state.user_balance.bonus !== '') ? _c('span', {
    staticClass: "font-weight-500"
  }, [_c('a', {
    class: {
      'color-red': this.$store.state.user_balance.bonus < 0
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.GoToOperation('bonus')
      }
    }
  }, [_c('Money', {
    attrs: {
      "value": _vm._f("money2")(this.$store.state.user_balance.bonus)
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "font-weight-500",
    domProps: {
      "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
    }
  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row main-wrapper"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sideMenuVisible),
      expression: "sideMenuVisible"
    }],
    staticClass: "col-sm-2 sidebar"
  }, [(this.$store.state.user_type === 'client' && _vm.isAccess('service/create')) ? _c('span', {
    staticClass: "w5-create-vds-button btn btn-submit full-width font-weight-400 margin-bottom-15 padding-0",
    on: {
      "click": _vm.createVdsByClient
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "plus"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-sm"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/create')) + " ")]), _c('span', [_vm._v(_vm._s(_vm._f("ftc")('server/server')))])], 1) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-sidebar"
  }, _vm._l((_vm.Config.leftMenu), function(item, what) {
    return (_vm.isAccess(item.link)) ? _c('li', {
      key: what,
      on: {
        "click": _vm.clickOnSideMenu
      }
    }, [_c('router-link', {
      ref: what === 'ticket' ? 'ticket' : item.link.replace(/\//g, '_'),
      refInFor: true,
      attrs: {
        "to": item.link
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t \t" + _vm._s(_vm._f("ftc")(item.title)) + "\n\t\t\t\t\t\t\t \t"), _vm._v(" "), (what === 'ticket' && _vm.$store.state.ticketData && _vm.$store.state.ticketData.counters && _vm.$store.state.ticketData.counters.all && _vm.$store.state.ticketData.counters.all > 0) ? _c('span', {
      staticClass: "badge ticket-message-counter-badge margin-left-6"
    }, [_vm._v("\n\t\t\t\t\t\t\t \t\t\t" + _vm._s(_vm.$store.state.ticketData.counters.all) + "\n\t\t\t\t\t\t\t \t")]) : _vm._e(), _vm._v(" "), (what === 'request' && _vm.$store.state.requestCounter && _vm.$store.state.requestCounter.all && _vm.$store.state.requestCounter.all > 0) ? _c('span', {
      staticClass: "badge ticket-message-counter-badge margin-left-6"
    }, [_vm._v("\n\t\t\t\t\t\t\t \t\t\t" + _vm._s(_vm.$store.state.requestCounter.all) + "\n\t\t\t\t\t\t\t \t")]) : _vm._e()])], 1) : _vm._e()
  }), 0), _vm._v(" "), (this.$store.state.user_type === 'client') ? _c('div', {
    staticClass: "w5-client-balance"
  }, [(_vm.$store.state.user_balance.real !== '') ? _c('div', {
    staticClass: "info-box-balance"
  }, [_c('span', {
    staticClass: "info-box-balance-icon bg-aqua",
    on: {
      "click": function($event) {
        return _vm.GoToOperation('real')
      }
    }
  }, [_c('font-awesome-icon', {
    staticClass: "color-white",
    attrs: {
      "icon": _vm.AppName == 'vdsina.com' ? 'dollar-sign' : 'ruble-sign'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "info-box-balance-content real-balance"
  }, [_c('span', {
    staticClass: "info-box-balance-text"
  }, [_vm._v(_vm._s(_vm._f("ftc")('operation/real_balance_short')) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-balance-value for-balance",
    class: {
      'color-red': _vm.$store.state.user_balance.real < 0
    },
    on: {
      "click": function($event) {
        return _vm.GoToOperation('real')
      }
    }
  }, [_c('Money', {
    attrs: {
      "value": _vm._f("money2")(_vm.$store.state.user_balance.real)
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "for-balance-currency",
    domProps: {
      "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user_balance.bonus !== '') ? _c('div', {
    staticClass: "info-box-balance"
  }, [_c('span', {
    staticClass: "info-box-balance-icon bg-aqua",
    on: {
      "click": function($event) {
        return _vm.GoToOperation('bonus')
      }
    }
  }, [_c('font-awesome-icon', {
    staticClass: "color-white",
    attrs: {
      "icon": "piggy-bank"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "info-box-balance-content bonus-balance"
  }, [_c('span', {
    staticClass: "info-box-balance-text"
  }, [_vm._v(_vm._s(_vm._f("ftc")('operation/purse_bonus')) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-balance-value for-balance",
    class: {
      'color-red': _vm.$store.state.user_balance.bonus < 0
    },
    on: {
      "click": function($event) {
        return _vm.GoToOperation('bonus')
      }
    }
  }, [_c('Money', {
    attrs: {
      "value": _vm._f("money2")(_vm.$store.state.user_balance.bonus)
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "for-balance-currency",
    domProps: {
      "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user_forecast) ? _c('div', {
    staticClass: "info-box-balance"
  }, [_c('span', {
    staticClass: "info-box-balance-icon bg-gray"
  }, [_c('font-awesome-icon', {
    staticClass: "color-white",
    attrs: {
      "icon": "exclamation-circle"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "info-box-balance-content"
  }, [_c('span', {
    staticClass: "info-box-balance-text"
  }, [_vm._v(_vm._s(_vm._f("ftc")('operation/forecast')) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-balance-value"
  }, [_vm._v(_vm._s(_vm._f("date")(_vm.$store.state.user_forecast, 'd.m.Y')))]), _vm._v(" "), _c('notice', {
    attrs: {
      "text": _vm._f("ftc")('main/forecast_notice'),
      "small": true
    }
  })], 1)]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10",
    class: _vm.$store.state.user_type === 'admin' ? 'main-for-admin' : 'main-for-client'
  }, [_c('div', {
    staticClass: "mobile-tabs-button margin-10-0 visible-xs"
  }, [_c('span', {
    staticClass: "cursor-pointer",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openMibileTabsMenu($event)
      }
    }
  }, [(Object.keys(_vm.tabs).length > 1) ? _c('font-awesome-icon', {
    attrs: {
      "icon": "chevron-down"
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "h4"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.mobileShowUpperTab)))])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeControl"
    }
  }, [(Object.keys(_vm.tabs).length > 1) ? _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mobileTabsMenuShow),
      expression: "mobileTabsMenuShow"
    }, {
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.hideMibileTabsMenu),
      expression: "hideMibileTabsMenu"
    }],
    staticClass: "mobile-tabs-menu"
  }, _vm._l((_vm.tabs), function(tab, idx) {
    return (_vm.isAccess(_vm.makeTabUrl(idx, tab))) ? _c('li', {
      key: idx,
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.hideMibileTabsMenu($event)
        }
      }
    }, [_c('router-link', {
      attrs: {
        "to": _vm.makeTabUrl(idx, tab)
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(tab))), (_vm.counterTicketTab(idx)) ? _c('span', {
      staticClass: "badge ticket-message-counter-badge margin-left-6"
    }, [_vm._v(_vm._s(_vm.counterTicketTab(idx)))]) : _vm._e()])], 1) : _vm._e()
  }), 0) : _vm._e()])], 1), _vm._v(" "), (_vm.tabs) ? _c('ul', {
    staticClass: "nav nav-tabs hidden-xs"
  }, _vm._l((_vm.tabs), function(tab, idx) {
    return (_vm.isAccess(_vm.makeTabUrl(idx, tab))) ? _c('li', {
      key: idx,
      class: {
        active: _vm.ActiveTab === idx
      }
    }, [_c('router-link', {
      attrs: {
        "to": _vm.makeTabUrl(idx, tab)
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(tab))), (_vm.counterTicketTab(idx)) ? _c('span', {
      staticClass: "badge ticket-message-counter-badge margin-left-6"
    }, [_vm._v(_vm._s(_vm.counterTicketTab(idx)))]) : _vm._e()])], 1) : _vm._e()
  }), 0) : _vm._e(), _vm._v(" "), _c('router-view')], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showConfirmModalDialog),
      expression: "showConfirmModalDialog"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideConfirmModalDialog
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.confirmModalDialogTitle ? _vm.confirmModalDialogTitle : '')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideConfirmModalDialog
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.confirmModalDialogText),
      expression: "confirmModalDialogText"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    on: {
      "click": _vm.confirmModalDialogCallback
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/confirm')))])])])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75a7533c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workBoard.vue
// module id = 763
// module chunks = 0